import React from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import {
  CheckBounceProcessSearchCriteria,
  RestCheckBounceProcessListRequest,
  RestPageListBean,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmptyString } from "../gui_components/Util.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { AccountReceivableService } from "../services/AccountReceivableService.js";
export class CheckBounceLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let resetCriteria = new CheckBounceProcessSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new CheckBounceProcessSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let checkBounceLookupCriteria = new CheckBounceProcessSearchCriteria();
    checkBounceLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = CheckBounceLookupCriteriaHandler(
      companyCode,
      checkBounceLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      checkBounceLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getCheckBounceStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition("Status", "status", 0, false); //2
    this.addColumnDefinition("CustomerCode", "customerCode", 0, false); //3
    this.addColumnDefinition("CustomerName", "customerName", 0, false);
    this.addColumnDefinition("CheckAmount", "checkAmount", 1, false);
    this.addColumnDefinition("CreatedDate", "createdDate", 0, false);
  }
  loadCheckBounceList = (lookup_dialog, pageNumber, searchCriteria) => {
    let check_searchcriteria = new CheckBounceProcessSearchCriteria(); //To be fetched from CriteriaHandler
    check_searchcriteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      check_searchcriteria.checkBounceProcessNumber =
        searchCriteria.checkBounceProcessNumber;
      check_searchcriteria.checkBounceProcessNumberContains =
        searchCriteria.checkBounceProcessNumberContains;
      check_searchcriteria.checkBounceProcessNumberStartsWith =
        searchCriteria.checkBounceProcessNumberStartsWith;
    }
    let pageList = new RestPageListBean();
    pageList.pageSize = 50; //TODO --> Fetch from Config
    pageList.currentPage = pageNumber;
    pageList.pageNumber = pageNumber;
    let requestInput = new RestCheckBounceProcessListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = check_searchcriteria;
    AccountReceivableService.getCheckBounceProcessPageList(
      requestInput,
      (response) => this.loadCheckBouncePageResponse(response, lookup_dialog),
      this.loadCheckBouncePageError
    );
  };
  loadCheckBouncePageResponse = (response, lookup_dialog) => {
    let checkBounceList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.checkBounceProcessPageList != null &&
      response.data.checkBounceProcessPageList.checkBounceProcesses !== null
    ) {
      checkBounceList =
        response.data.checkBounceProcessPageList.checkBounceProcesses;
      totalCount = response.data.checkBounceProcessPageList.totalCount;
      currentPageNumber = response.data.checkBounceProcessPageList.currentPage;
      pageSize = response.data.checkBounceProcessPageList.pageSize;
      checkBounceList.map((cb) => {
        cb.status = ModuleUtils.getCheckBounceStatusCaption(cb.status);
      });
    }
    let lookup_result_details = new LookupResultDetails();
    this.lookupdata = checkBounceList;
    lookup_result_details.pageData = this.lookupdata;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadCheckBouncePageError = (error) => {
    ShowError(error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.checkBounceProcessNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.checkBounceProcessNumberContains = filterText;
        this.searchCriteria = new CheckBounceProcessSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadCheckBounceList(lookup_dialog, pageNumber, search);
    }
  }
}
const CheckBounceLookupCriteriaHandler = (companyCode) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new CheckBounceProcessSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new CheckBounceProcessSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>CheckBounce#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="checkBounceProcessNumber"
                  name="checkBounceProcessNumber"
                  onChange={this.onChange}
                  value={searchCriteria.checkBounceProcessNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>CheckBounce StartsWith</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="checkBounceProcessNumberStartsWith"
                  name="checkBounceProcessNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.checkBounceProcessNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>CheckBounce Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="checkBounceProcessNumberContains"
                  name="checkBounceProcessNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.checkBounceProcessNumberContains}
                />
              </Col>
            </Row>
            <Row className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
